export default "__VITE_ASSET__CnDBkA4t__"